export default "__VITE_ASSET__JjOWVv1Q__"